import { types } from 'mobx-state-tree';
export const CropzoneBoard = types.model({
  filter: types.model({
    sort: types.model({
      sortType: types.string,
      order: types.string
    })
  }),
  filterModalVisible: false
}).actions(self => ({
  setSortBy(sortBy: {
    sortType: string;
    order: string;
  }) {
    self.filter.sort = sortBy;
  },
  toggleOrder() {
    self.filter.sort.order = self.filter.sort.order === 'asc' ? 'desc' : 'asc';
  },
  setFilterModalVisible(isVisible: boolean) {
    self.filterModalVisible = isVisible;
  }
})).actions(self => ({
  resetSort() {
    self.setSortBy({
      sortType: 'planting_date',
      order: 'desc'
    });
  }
})).views(self => ({
  get sortBy() {
    return `${self.filter.sort.sortType}_${self.filter.sort.order}`;
  }
}));